module.exports = __webpack_public_path__ + "img/map_1791458174624_11300.d647612c.jpg";